import { useState } from 'react';
import {
    IconCancel,
    IconCheck,
    IconSearch,
    IconStar,
    IconWhatsApp
} from '../../componentes/Icons';
import './Agenda.css';

const SecaoAgenda = ({
    selectedDate,
    setSelectedDate,
    generateDailyAgendaPDF,
    selectedBarber,
    setSelectedBarber,
    barbers,
    agendaSearch,
    setAgendaSearch,
    agendaStatusFilter,
    setAgendaStatusFilter,
    groupedAgenda,
    onUpdateStatus,
    handleRemind,
    agendaAppointments
}) => {
    const [viewMode, setViewMode] = useState('list'); // 'list' ou 'grid'

    // Horários da grade (08:00 até 20:00)
    const timeSlots = [];
    for (let h = 8; h <= 20; h++) {
        timeSlots.push(`${h.toString().padStart(2, '0')}:00`);
    }

    const parseDuration = (durationStr) => {
        if (!durationStr) return 30;
        const minsMatch = durationStr.match(/(\d+)\s*min/);
        const hoursMatch = durationStr.match(/(\d+)\s*h/);
        let total = 0;
        if (hoursMatch) total += parseInt(hoursMatch[1]) * 60;
        if (minsMatch) total += parseInt(minsMatch[1]);
        if (total === 0) {
            const numMatch = durationStr.match(/(\d+)/);
            total = numMatch ? parseInt(numMatch[1]) : 30;
        }
        return total;
    };

    const calculateEndTime = (startTime, durationMinutes) => {
        if (!startTime) return '';
        const [hours, minutes] = startTime.split(':').map(Number);
        const totalMinutes = hours * 60 + minutes + durationMinutes;
        const endHours = Math.floor(totalMinutes / 60);
        const endMinutes = totalMinutes % 60;
        return `${endHours.toString().padStart(2, '0')}:${endMinutes.toString().padStart(2, '0')}`;
    };

    const renderGridView = () => {
        const activeBarbers = selectedBarber === 'Todos' ? barbers : barbers.filter(b => b.name === selectedBarber);

        return (
            <div className="calendar-grid-container fade-in">
                <div className="calendar-header-grid">
                    <div className="time-col-header">Hora</div>
                    {activeBarbers.map(barber => (
                        <div key={barber.id} className="barber-col-header">
                            {barber.name}
                        </div>
                    ))}
                </div>

                <div className="calendar-body">
                    {timeSlots.map(time => (
                        <div key={time} className="calendar-row">
                            <div className="time-cell">{time}</div>
                            {activeBarbers.map(barber => {
                                const appMatch = agendaAppointments.find(a =>
                                    a.barber === barber.name &&
                                    a.time === time &&
                                    a.status !== 'Cancelado'
                                );

                                return (
                                    <div key={barber.id + time} className="calendar-cell">
                                        {appMatch && (
                                            <div
                                                className={`app-preview status-${appMatch.status.toLowerCase()}`}
                                                onClick={() => handleRemind(appMatch)}
                                                title={`${appMatch.client}: ${appMatch.service}`}
                                            >
                                                <span className="app-client">{appMatch.client}</span>
                                                <span className="app-service">{appMatch.service}</span>
                                                <span className="app-duration">termina às {calculateEndTime(appMatch.time, appMatch.durationMinutes || parseDuration(appMatch.duration))}</span>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <div className="section-agenda fade-in">
            <div className="section-header-row">
                <div className="agenda-title-group">
                    <h2 className="section-title">Agenda: <span className="current-selected-date">{selectedDate.split('-').reverse().join('/')}</span></h2>
                    <input
                        type="date"
                        className="agenda-date-picker"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                    />
                </div>
                <div className="agenda-header-actions">
                    <div className="view-mode-toggle">
                        <button
                            className={`toggle-btn ${viewMode === 'list' ? 'active' : ''}`}
                            onClick={() => setViewMode('list')}
                            title="Visão em Lista"
                        >
                            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" />
                            </svg>
                        </button>
                        <button
                            className={`toggle-btn ${viewMode === 'grid' ? 'active' : ''}`}
                            onClick={() => setViewMode('grid')}
                            title="Visão Visual (Timeline)"
                        >
                            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
                                <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" />
                            </svg>
                        </button>
                    </div>

                    <button
                        className="export-agenda-pdf-btn"
                        onClick={generateDailyAgendaPDF}
                        title="Baixar lista de atendimentos do dia em PDF"
                    >
                        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" />
                        </svg>
                    </button>
                </div>
            </div>

            <div className="barber-agenda-selector fade-in">
                <button
                    className={`barber-chip ${selectedBarber === 'Todos' ? 'active' : ''}`}
                    onClick={() => setSelectedBarber('Todos')}
                >
                    <div className="chip-avatar">👥</div>
                    <span>Todos</span>
                </button>
                {barbers.map(barber => (
                    <button
                        key={barber.id}
                        className={`barber-chip ${selectedBarber === barber.name ? 'active' : ''}`}
                        onClick={() => setSelectedBarber(barber.name)}
                    >
                        <img src={barber.image || '/imagens/fotobarber.PNG'} alt={barber.name} className="chip-img" />
                        <span>{barber.name}</span>
                    </button>
                ))}
            </div>

            <div className="agenda-list-enhanced">
                {viewMode === 'list' ? (
                    <>
                        <div className="agenda-controls-row">
                            <div className="agenda-search-box">
                                <IconSearch />
                                <input
                                    type="text"
                                    placeholder="Buscar cliente ou telefone..."
                                    value={agendaSearch}
                                    onChange={(e) => setAgendaSearch(e.target.value)}
                                />
                                {agendaSearch && (
                                    <button className="clear-search" onClick={() => setAgendaSearch('')}>
                                        <IconCancel />
                                    </button>
                                )}
                            </div>
                            <div className="agenda-status-filters">
                                {['Todos', 'Pendente', 'Remarcado', 'Confirmado', 'Concluido', 'Cancelado'].map(status => (
                                    <button
                                        key={status}
                                        className={`status-filter-btn ${status.toLowerCase()} ${agendaStatusFilter === status ? 'active' : ''}`}
                                        onClick={() => setAgendaStatusFilter(status)}
                                    >
                                        {status}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className="agenda-groups-container">
                            {Object.entries(groupedAgenda).map(([groupName, apps]) => {
                                if (apps.length === 0) return null;
                                return (
                                    <div key={groupName} className="agenda-group">
                                        <h3 className="group-title">
                                            {groupName}
                                            <span className="group-count">{apps.length}</span>
                                        </h3>
                                        <div className="agenda-cards-grid">
                                            {apps.map(app => (
                                                <div key={app.id} className={`appointment-card-v2 status-${app.status.toLowerCase()}`}>
                                                    <div className="card-top">
                                                        <div className="card-time-box">
                                                            <span className="card-time">{app.time}</span>
                                                            <span className="card-date-sm">{app.date.split('-').reverse().join('/')}</span>
                                                        </div>
                                                        <div className={`card-status-pill ${app.status.toLowerCase()}`}>
                                                            {app.status}
                                                        </div>
                                                    </div>

                                                    <div className="card-body">
                                                        <div className="card-client-info">
                                                            <h4 className="card-client-name">{app.client}</h4>
                                                            <div className="card-client-meta">
                                                                <IconWhatsApp size={12} />
                                                                <span>{app.whatsapp || 'Sem número'}</span>
                                                            </div>
                                                        </div>
                                                        <div className="card-service-info">
                                                            <span className="card-service-name">{app.service}</span>
                                                            <span className="card-barber-name">{app.barber}</span>
                                                        </div>
                                                    </div>

                                                    <div className="card-footer">
                                                        <div className="card-price">{app.price}</div>
                                                        <div className="card-actions">
                                                            {(app.status === 'Pendente' || app.status === 'Agendado' || app.status === 'AGENDADO' || app.status === 'Remarcado') && (
                                                                <button className="action-circle confirm" onClick={() => onUpdateStatus(app.id, 'Confirmado')} title="Confirmar">
                                                                    <IconCheck />
                                                                </button>
                                                            )}
                                                            {app.status !== 'Concluido' && app.status !== 'Cancelado' && (
                                                                <button className="action-circle complete" onClick={() => onUpdateStatus(app.id, 'Concluido')} title="Concluir">
                                                                    <IconStar size={14} fill={true} />
                                                                </button>
                                                            )}
                                                            <button className="action-circle wa" onClick={() => handleRemind(app)} title="Lembrete">
                                                                <IconWhatsApp />
                                                            </button>
                                                            {app.status !== 'Cancelado' && (
                                                                <button className="action-circle cancel" onClick={() => onUpdateStatus(app.id, 'Cancelado')} title="Cancelar">
                                                                    <IconCancel />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                );
                            })}

                            {agendaAppointments.length === 0 && (
                                <div className="agenda-empty-state">
                                    <div className="empty-icon">📅</div>
                                    <p>Nenhum agendamento encontrado.</p>
                                    {agendaSearch && <button className="clear-search-btn" onClick={() => setAgendaSearch('')}>Limpar busca</button>}
                                </div>
                            )}
                        </div>
                    </>
                ) : (
                    renderGridView()
                )}
            </div>
        </div>
    );
};

export default SecaoAgenda;
